// src/components/ChatWindow.js
import React, { useState, useRef, useCallback } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { RoutesPaths } from '../../../Router/constant';
import { useNavigate } from 'react-router';
import ContentEditable from 'react-contenteditable';
import { ADMIN_USER, backendUrl, capitalizeFirstLetter, GOLD_QUANTITY_LIST, PUSH_NOTIFICATION_MODULE, SUBSCRIPTION_MODULE_TYPE, SUPPORTED_PAYMENT_METHOD_NAME } from '../../../constants';
import TextMessageBox from '../TextMessageBox';
import { chatMediaPreviewerAction } from '../../../actions/chat';
import CreatePayment from '../CreatePayment';
import CalendlyPopup from '../CalendlyPopup';
import { getIsPlanValidAction, manualPaymentAction, paymentLinkStateAction, setPaymentSteps, setQuantity, setTripleaUrl } from '../../../actions/stripe';
import { getSingleSubscriptonPlan } from '../../../actions/subscriptionPlan';
import Currency from '../../../components/currency';
import CurrencyFormat from '../../../components/currencyFormat/currencyFormat';
import PayNowButton from './PayNowButton';
import TimeFormat from '../../../components/timeFormat/timeFormat';
var holdCurrentDate = null;

export const downloadMediaOnFly = (item) => {
  const reader = new FileReader();
  reader.onload = (event) => {
    const fileUrl = event.target.result;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = item.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  reader.readAsDataURL(item);
}




export const downloadMedia = (media) => {
  const url = backendUrl + media.filename
  window.open(
    url,
    '_blank' // <- This is what makes it open in a new window.
  );
}

export default function ChatWindowStatic({
  chat,
  messages,
  isMessageLoading,
  highlightMessageId,
  onSend,
  searchQuery,
  emailError,
  isObjective,
  investorDescribe,
  askNameEmail,
  errors,
  register,
  handleSubmit,
  onSubmit,
  advisorTimer,
  secondsLeft,
  submitLoader,
  publicProfile,
  singleCampaignDetail,
  inviterDetails
}) {
  const [text, setText] = useState('');
  const endRef = useRef();
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch()
  const textAreaRef = useRef(null);
  const sendMessageButton = useRef(null);
  const { chatMedia } = useSelector((state) => state.chat);
  const [paymentLinkModal, setPaymentLinkModal] = useState(false);
  const [calendlyPopup, setCalendlyPopup] = useState(false);
  const [calendlyUrl, setCalendlyUrl] = useState(null);
  const { selectedCompany } = useSelector((state) => state.company);
  const [loaderPay, setloaderPay] = useState(false);

  const navigate = useNavigate()

  // Scroll behavior: highlight takes priority; otherwise go to bottom
  const send = async (value, type = false) => {
    const c = type ? value.trim() : text.trim();
    if (c.length === 0) {
      return;
    }
    onSend(c);
    setText('');
  };

  const getSeperatedDate = (messageDate) => {
    var showDate = false;
    var currentMessageDate = moment(messageDate).format("YYYYMMDD");
    showDate = holdCurrentDate !== currentMessageDate ? true : false;
    holdCurrentDate = currentMessageDate;
    if (showDate) {
      return (
        <div className="seperate-line">
          <span>
            {moment(messageDate).format("ddd, MMM D")}{" "}
            {moment(messageDate).format("Y") !== moment().format("Y")
              ? "," + moment(messageDate).format("Y")
              : ""}
          </span>
        </div>
      );
    } else {
      return null;
    }
  };

  const dateFormatShow = (dateFilter) => {
    var date = new Date(dateFilter).toLocaleTimeString([], {
      hourCycle: "h12",
      hour: "2-digit",
      minute: "2-digit",
    });
    return date;
  };

  const handleKeyPress = (event) => {
    if (
      event.charCode === 13 &&
      !event.ctrlKey &&
      !event.shiftKey &&
      event.key === "Enter"
    ) {
      event.preventDefault(); // Prevent adding a newline
      // onMessageSend()
      sendMessageButton.current.click();
    }
  };

  const hanldeCalendlyClick = (url) => {
    setCalendlyPopup(true);
    setCalendlyUrl(url)
  }

  const formatTime = secs => {
    const minutes = String(Math.floor(secs / 60)).padStart(2, '0');
    const seconds = String(secs % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  };


  const goToPlan = async (data) => {
    if (data?.slug) {
      const { id } = selectedCompany;
      setloaderPay(data?._id);
      var response = await dispatch(getIsPlanValidAction(data?.slug))
      if (response?.data === 'Valid') {
        var resp = await dispatch(getSingleSubscriptonPlan(id, data?.slug));
        if (resp?.status) {
          dispatch(manualPaymentAction(0))
          dispatch(setQuantity(GOLD_QUANTITY_LIST[0]))
          dispatch(setPaymentSteps(2));
          dispatch(setTripleaUrl(null, false))
          dispatch(paymentLinkStateAction({
            sid: chat?._id,
            pageType: "chat"
          }))
          setloaderPay(false);
          if (resp?.status) {
            navigate(RoutesPaths.QUOTATION_PUBLIC.replace(":slug", data?.slug));
          }
        }
      } else {
        setloaderPay(false);
      }
    }
  };

  const gotoPaymentStatus = (data) => {
    navigate(RoutesPaths.PUBLIC_PAYMENT_STATUS.replace(":slug", data?.data?.plan?.slug))
  }

  const gotoActivateBusiness = (uniqueToken) => {
    if (uniqueToken) {
      window.open(`${RoutesPaths.ACTIVATE_BUSINESS}?activationToken=${uniqueToken}`, "_blank", "noopener,noreferrer")
    }
  }

  const renderMessageSkeleton = () => (
    <>
      {[0, 1, 2].map(index => (
        <div
          id={`message-static-skeleton-${index}`}
          className={`messageListOuter staticMessageSkeleton ${index === 1 ? "ownProperty" : ""}`}
          key={index}
        >
          <div className="messageListInner">
            {index !== 1 && <div className="profile_photo staticSkeletonAvatar"></div>}
            <div className="messagebyUser">
              <div className="userName">
                <div className="userMessage">
                  {index !== 1 && <div className="staticSkeletonName"></div>}
                  <div className="messagingService">
                    <div className="staticSkeletonLine"></div>
                    <div className="staticSkeletonLine short"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );

  const getMessageSenderName = (message) => {
    if (!message?.sender) return "kimbocorp assistant";
    if (message?.sender?.email === ADMIN_USER[0]) return "kimbocorp advisor";
    return [message?.sender?.first_name, message?.sender?.last_name].filter(Boolean).join(" ");
  }

  const printMessage = (message) => {
    const isReceiver = user.id !== message?.sender?.id;

    return (
      <>
        {message?.module === PUSH_NOTIFICATION_MODULE.FILE ? (
          <>
            {message.content && (
              <TextMessageBox
                searchMessageId={highlightMessageId}
                message={message}
                searchQuery={searchQuery}
              />
            )}
            <div className="message-box-hold-outer">
              {message?.data?.map((item, index) => (
                <div className="message-box-hold" key={index}>
                  <span key={index} className="addMedia" onClick={() => item?.mimetype.startsWith('image/') ? setOpenImageViewer(item) : downloadMedia(item)}>
                    {item?.mimetype.startsWith('image/') ? (
                      <span className="imagePreviewChat" style={{ backgroundImage: `url(${backendUrl + item.filename})` }}></span>
                    ) : (
                      <>
                        <span className="addMediaPadding">
                          <img className="imageView" src="assets/img/imageView.svg" alt="" />
                          &nbsp;<span className="fileName">{item.originalName}</span>
                        </span>
                      </>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </>
        ) : message?.module === PUSH_NOTIFICATION_MODULE.CALENDLY ?
          <div
            onClick={() => hanldeCalendlyClick(message?.data)}
            className="payment-link-message">
            <div>
              <p className="message">{message?.content}</p>
              <button
                type="button"
                className="pay-now-btn"
              >
                Book a slot
              </button>
            </div>
          </div> :
          message?.module === PUSH_NOTIFICATION_MODULE.NAME_EMAIL ?
            <div className="payment-link-message">
              <div>
                <p className="message">Name: {message?.data?.first_name} {message?.data?.last_name}</p>
                <p className="message">Email: {message?.data?.email}</p>
              </div>
            </div>
            : message?.module === PUSH_NOTIFICATION_MODULE.COUNTDOWN_MESSAGE ? (
              (
                <>
                  <TextMessageBox
                    searchMessageId={highlightMessageId}
                    message={message}
                    searchQuery={searchQuery}
                  />
                  {advisorTimer &&
                    <div className="timer-container">
                      <div className="progress-bar">
                        <div
                          className="filled-bar"
                          style={{ width: `${(secondsLeft / 120) * 100}%` }}
                        />
                      </div>
                      <span className="timer-text">{formatTime(secondsLeft)}</span>
                    </div>
                  }
                </>
              )
            ) : message?.module === PUSH_NOTIFICATION_MODULE.PAYMENTLINK ?
              <>
                {user.id !== message?.sender?.id ?
                  <div className="payment-link-message">
                    <div className="payment-link-hold">
                      <div className="cursorPointer payment-link-img"></div>
                    </div>
                    <div>
                      <h6>{message?.sender?.first_name ? message?.sender?.first_name + " " + message?.sender?.last_name : "Admin"} has requested a payment</h6>
                      {message?.data &&
                        <>
                          <p className="message">
                            Purpose: <strong>{message?.data?.name}</strong>
                          </p>
                          <p className="message mb-2">
                            Amount: <strong><Currency currency={message?.data?.currency?.value} />{" "}
                              <CurrencyFormat
                                currency={message?.data?.currency?.value}
                                value={parseFloat(message?.data?.price)}
                                decimal={2}
                              />
                            </strong>
                          </p>
                          <p className="message">
                            Please proceed with the payment using the link below:
                          </p>
                          <PayNowButton
                            message={message}
                            onPay={goToPlan}
                            loaderPay={loaderPay}
                          />
                        </>}
                    </div>
                  </div>
                  :
                  <div className="payment-link-message">
                    <div className="payment-link-hold">
                      <div className="cursorPointer payment-link-img"></div>
                    </div>
                    <div>
                      <h6>Payment Request Sent</h6>
                      {message?.data &&
                        <>
                          <p className="message">
                            Purpose: <strong>{message?.data?.name}</strong>
                          </p>
                          <p className="message mb-2">
                            Amount: <strong><Currency currency={message?.data?.currency?.value} />{" "}
                              <CurrencyFormat
                                currency={message?.data?.currency?.value}
                                value={parseFloat(message?.data?.price)}
                                decimal={2}
                              />
                            </strong>
                          </p>
                        </>
                      }
                    </div>
                  </div>
                }
              </> :
              message?.module === PUSH_NOTIFICATION_MODULE.ACTIVATE_BUSINESS ? (
                <>
                  <TextMessageBox
                    searchMessageId={highlightMessageId}
                    message={message}
                    searchQuery={searchQuery}
                  />
                  <button
                    type="button"
                    className="pay-now-btn"
                    onClick={() => gotoActivateBusiness(message?.data?.uniqueToken)}
                  >
                    Open secure link
                  </button>
                </>
              ) :
              message?.module === PUSH_NOTIFICATION_MODULE.PAYMENTLINKPAID ? (
                <div
                  className="payment-receipt-card cursorPointer"
                  onClick={() => gotoPaymentStatus(message)}
                >
                  <h6 className={`receipt-title ${!isReceiver ? "adminText" : ""}`}>
                    {isReceiver
                      ? message?.sender?.first_name
                        ? `${message?.sender?.first_name} ${message?.sender?.last_name}`
                        : "Admin has sent you payment receipt"
                      : "Payment receipt sent"}
                  </h6>

                  {message?.data && (
                    <>
                      <p className={`receipt-row ${!isReceiver ? "adminText" : ""}`}>
                        Amount:{" "}
                        <strong>
                          <Currency currency={message?.data?.payment?.currency || ""} />
                          <CurrencyFormat
                            currency={message?.data?.payment?.currency}
                            value={parseFloat(
                              message?.data?.payment?.amount / 100
                            )}
                            decimal={2}
                          />
                        </strong>
                      </p>

                      <p className={`receipt-row ${!isReceiver ? "adminText" : ""}`}>
                        Status:{" "}
                        <strong>
                          {capitalizeFirstLetter(
                            message?.data?.payment?.payment_status
                          )}
                        </strong>
                      </p>

                      <p className={`receipt-row ${!isReceiver ? "adminText" : ""}`}>
                        Transaction ID:{" "}
                        <strong>{message?.data?.payment?.paymentId}</strong>
                      </p>

                      {message?.data?.plan?.planType?.value ===
                        SUBSCRIPTION_MODULE_TYPE.CUSTOM && (
                          <p className={`receipt-row ${!isReceiver ? "adminText" : ""}`}>
                            Quotation ID:{" "}
                            <strong>
                              Quotation {message?.data?.plan?.quotationId}
                            </strong>
                          </p>
                        )}

                      <p className={`receipt-row ${!isReceiver ? "adminText" : ""}`}>
                        Payment Time:{" "}
                        <strong>
                          <TimeFormat
                            time={message?.data?.payment?.createdAt}
                          />
                        </strong>
                      </p>

                      <p className={`receipt-row ${!isReceiver ? "adminText" : ""}`}>
                        Payment Method:{" "}
                        <strong>
                          {
                            SUPPORTED_PAYMENT_METHOD_NAME[
                            message?.data?.payment
                              ?.paymentMethodSelection
                            ]
                          }
                        </strong>
                      </p>
                    </>
                  )}
                </div>
              ) :
                <TextMessageBox
                  searchMessageId={highlightMessageId}
                  message={message}
                  searchQuery={searchQuery}
                />
        }
      </>
    );
  };


  function handlePaste(e) {
    e.preventDefault();

    // Get plain text from clipboard
    const text = e.clipboardData.getData('text/plain');

    // Insert plain text at cursor
    document.execCommand('insertText', false, text?.trimRight());
  }

  const setOpenImageViewer = (item) => {
    const indexValueChatMedia = chatMedia.findIndex(x => x.filename === item.filename)
    openImageViewer(indexValueChatMedia)
  }


  const openImageViewer = useCallback((index) => {
    dispatch(chatMediaPreviewerAction(index, true));
  }, []);

  const { campaign } = singleCampaignDetail

  const imagePath = campaign?.company?.isAdvisor
    ? campaign?.creator?.profilePic?.filename
    : campaign?.company?.logo;

  const imageUrl = imagePath ? `${backendUrl}${imagePath}` : null;
  const inviterName = `${inviterDetails?.inviter_first_name || ""} ${inviterDetails?.inviter_last_name || ""}`.trim();
  const activateBusinessStickyMessage = !isMessageLoading
    ? messages.find(msg => msg?.module === PUSH_NOTIFICATION_MODULE.ACTIVATE_BUSINESS)
    : null;
  const visibleMessages = activateBusinessStickyMessage
    ? messages.filter(msg => msg?.module !== PUSH_NOTIFICATION_MODULE.ACTIVATE_BUSINESS)
    : messages;

  return (
    <>
      {!campaign && inviterName &&
        <div className='chat-inviter-holder'>
          <div className='chat-inviter-card'>
            <div className='chatUserNameHolder'>
              <div className="business-image hasText me-3"></div>
              <div>
                <h4 className='chatUserName'>{inviterName}</h4>
                <p>Inviter</p>
              </div>
            </div>
          </div>
        </div>
      }
      {campaign &&
        <div className='chat-campaign-holder'>
          <div className='chat-campaign-card'>
            <div className='chatUserNameHolder'>
              <div
                className={`business-image ${imageUrl ? "company-logo" : "hasText me-3"
                  }`}
                style={{
                  backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
                }}
              >
              </div>
              <div>
                <h4 className='chatUserName'>{campaign?.company?.companyName}</h4>
                {campaign?.company?.isAdvisor && <p>Advisor</p>}
              </div>
            </div>
          </div>
          <div className='chatCampaignHolder'>
            <p className='chatCampaignName'>Campaign: <span>{campaign?.name}</span></p>
            <p className='chatCampaignDesc'>{campaign?.description}</p>
          </div>
        </div>
      }
      {activateBusinessStickyMessage && (
        <div className="chat-campaign-holder staticActivationTopMessage">
          <div className="chat-campaign-card staticActivationHeader">
            <div className='chatUserNameHolder'>
              <div
                style={{ backgroundImage: `url(assets/img/Frame1.svg)` }}
                className="business-image company-logo"></div>
              <div>
                <h4 className='chatUserName'>{getMessageSenderName(activateBusinessStickyMessage)}</h4>
                <p>Business activation</p>
              </div>
            </div>
          </div>
          <div className='chatCampaignHolder staticActivationHolder'>
            <div
              className="staticActivationCopy"
              dangerouslySetInnerHTML={{
                __html: activateBusinessStickyMessage?.content,
              }}
            />
            <div className="staticActivationAction">
              <button
                type="button"
                className="staticActivationButton"
                onClick={() => gotoActivateBusiness(activateBusinessStickyMessage?.data?.uniqueToken)}
              >
                Open secure link
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Messages */}
      <div
        id="scrollable"
        className={`${campaign ? "messageHolderWithCampaign" : inviterName ? "messageHolderWithInviter" : ""}${activateBusinessStickyMessage ? " messageHolderWithStickyActivation" : ""} messageHolder customScroll`}
        style={{
          display: "flex",
          flexDirection: "column-reverse",
          width: "100%",
        }}
      >


        <div className="messageList">
          {isMessageLoading ? renderMessageSkeleton() : visibleMessages.map((msg, index) =>
            <div key={index}>
              <div>
                {getSeperatedDate(msg.updatedAt)}
                {msg.system ? (
                  <div className="joinedLeaveChat">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: msg.content,
                      }}
                    ></span>
                  </div>
                ) : (
                  <div
                    id={"message-" + msg._id}
                    className={`${((!user?.id && msg?.sender?.first_name === "user") || (user?.id && user?.id === msg?.sender?.id))
                      ? "messageListOuter ownProperty"
                      : "messageListOuter"
                      }${msg?.module === PUSH_NOTIFICATION_MODULE.ACTIVATE_BUSINESS ? " activateBusinessStickyMessage" : ""}`}
                  >
                    <div className="messageListInner">
                      <>
                        {((!user?.id && msg?.sender?.first_name !== "user") || (user?.id && user?.id !== msg?.sender?.id)) && (
                          <div
                            style={{ backgroundImage: `url(assets/img/Frame1.svg)` }}
                            className="profile_photo"></div>
                        )}
                      </>

                      <div className="messagebyUser">
                        <div className="userName">
                          <div className="userMessage">
                            {msg.sender ?
                              <>
                                {((!user?.id && msg?.sender?.first_name !== "user") || (user?.id && user?.id !== msg?.sender?.id)) && (
                                  <h4>
                                    <span>
                                      {msg?.sender?.email === ADMIN_USER[0] ? "kimbocorp advisor" : msg.sender?.first_name + " " + msg.sender?.last_name}
                                    </span>
                                    &nbsp;
                                  </h4>
                                )}
                              </>
                              :
                              <h4>
                                <span>
                                  kimbocorp assistant
                                </span>
                                &nbsp;
                              </h4>
                            }
                            <div className="messagingService">
                              {printMessage(msg)}
                            </div>
                            {((!user?.id && msg?.sender?.first_name === "user") || (user?.id && user?.id === msg?.sender?.id)) && (
                              <span className="currentMessageTime">
                                {dateFormatShow(msg.createdAt)}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div ref={endRef} />
        </div>
      </div>
      {!isMessageLoading && (emailError ? <div className='badgeConfirmHolder'>
        <div onClick={() => navigate(RoutesPaths.LANDING_PUBLIC, { replace: true })} className="badgeConfirm">Go back</div>
      </div>
        : isObjective ?
          <div className='badgeConfirmHolder'>
            <div onClick={() => send("Receive crypto and convert to fiat", true)} className="badgeConfirm">Receive crypto and convert to fiat</div>
            <div onClick={() => send("Setup a family office", true)} className="badgeConfirm">Setup a family office</div>
            <div onClick={() => send("Raise funding and issue shares", true)} className="badgeConfirm">Raise funding and issue shares</div>
            <div onClick={() => send("Start an online or consulting business", true)} className="badgeConfirm">Start an online or consulting business</div>
            <div onClick={() => send("Others", true)} className="badgeConfirm">Others</div>
          </div> :
          investorDescribe ? <div className='badgeConfirmHolder'>
            <div onClick={() => send("Investor or fund manager", true)} className="badgeConfirm">Investor or fund manager</div>
            <div onClick={() => send("Consultant or advisor", true)} className="badgeConfirm">Consultant or advisor</div>
            <div onClick={() => send("Startup founder or entrepreneur", true)} className="badgeConfirm">Startup founder or entrepreneur</div>
            <div onClick={() => send("Others", true)} className="badgeConfirm">Others</div>
          </div> :
            askNameEmail ?
              <div>
                <div className='badgeConfirmHolder'>
                  <div>
                    <input
                      maxLength={50}
                      autoComplete="nope"
                      type="text"
                      className="form-control"
                      readOnly={publicProfile ? true : false}
                      placeholder="Name"
                      {...register("name", {
                        required: true,
                        maxLength: 50,
                        minLength: 3,
                      })}
                    />
                    {errors.name?.type === "required" && (
                      <span className="errorMessage">
                        Name is required
                      </span>
                    )}
                    {errors.name?.type === "maxLength" && (
                      <span className="errorMessage">
                        Name may not be longer than 50 characters
                      </span>
                    )}
                    {errors.name?.type === "minLength" && (
                      <span className="errorMessage">
                        Minimum 3 characters required
                      </span>
                    )}
                  </div>
                  <div>
                    <input
                      maxLength={50}
                      autoComplete="nope"
                      type="email"
                      readOnly={
                        Array.isArray(publicProfile?.contactInfo?.email)
                          ? !!publicProfile.contactInfo.email[0]
                          : !!publicProfile?.contactInfo?.email
                      } className="form-control"
                      placeholder="Email"
                      {...register("email", {
                        required: true,
                        pattern:
                          /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
                      })}
                    />
                    {errors.email?.type === "required" && (
                      <span className="errorMessage">
                        Email is required
                      </span>
                    )}
                    {errors.email?.type === "pattern" && (
                      <span className="errorMessage">Email is invalid</span>
                    )}
                  </div>
                </div>
                <div className="badgeConfirmHolderColumn">
                  <button disabled={submitLoader} onClick={handleSubmit(onSubmit)} className="badgeConfirm">
                    {submitLoader && (<i className="animateSpin fa-solid fa-circle-notch"></i>)}&nbsp;
                    Submit
                  </button>
                </div>
              </div>
              : advisorTimer ? <></> :
                <div className="row message-input">
                  <div className="col-lg-12">
                    <div className="inputHolder inputHolderStatic">
                      <div
                        className={
                          "userListHolder"
                        }
                      >
                        <ContentEditable
                          id="text"
                          innerRef={textAreaRef}
                          html={text}
                          onChange={e => setText(textAreaRef.current.innerText)}
                          disabled={false} // use true to disable edition
                          onKeyPress={handleKeyPress}
                          onPaste={handlePaste}
                          className="textarea customScroll"
                          tagName="div"
                          placeholder="Write your message here..."
                        />
                        <div className="customButtons">
                          <button
                            type="submit"
                            ref={sendMessageButton}
                            onClick={() => send("", false)}
                          >
                            <img src="assets/img/sendBtn.svg" alt="" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="customButtonHolder">
                <div className="col-lg-4 customButtonsEditor">
                  <div className="col-lg-12">
                    <div className="styleMessage">
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          document.execCommand("bold", false, null);
                        }}
                        className="editText"
                      >
                        <img src="assets/img/boldMessage.svg" alt="" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 customButtons">
                  <div className="col-lg-12" ref={overlayRef}>
                    <button
                      type="submit"
                      ref={sendMessageButton}
                      onClick={() => send("", false)}
                    >
                      <img src="assets/img/sendBtn.svg" alt="" />
                    </button>
                  </div>
                </div>
              </div> */}
                </div>
      )}
      <CreatePayment show={paymentLinkModal} onClose={() => setPaymentLinkModal(false)} conversation={chat} />
      <CalendlyPopup showPopup={calendlyPopup} modalClose={() => setCalendlyPopup(false)} url={calendlyUrl} />
    </>

  );
}
